<template>
  <div class="home-page">
    <Header></Header>
    <div class="home-content mt50">
      <div class="content crfff ac por">
        <button  class="button mt30 crfff snapbot-btn" @click="goDetail('/snapbot')">
        </button>
        <div class="disflex mt50" style="justify-content: space-between;width: calc(100% - 4rem);">
          <div class="crfb7925 fs27 fw7">
            {{$t('ChancesLeft')}}: {{score}}
          </div>
          <div class="fs27 fw7" style="color:#FFC107" @click="goPurchaseChances">{{$t('BuyChances')}}</div>
        </div>
        <div class="mt50">
          <div class="land-content al">
            <div  v-for="(item,index) in product">
              <div  class="two" @click="goDetail(item.web_path)" >
                <img v-if="item.is_new" style="position: absolute;right: 0rem;top: 0rem;width: 15%" src="../../static/images/new.png"/>
                <div class="fs36" style="margin-top: 0.5rem">{{item.title}}</div>
                <img :src="item.image" loading="lazy" />
                <div class="disflex">
                  <span class="fs26">{{item.title_tip}}</span>
                  <button class="button mt30 crfff">
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer mt100">
      <div class="home-bottom ac mt50">
        <div class="footer-content ac">
          <a class="crfff" @click="goDetail('faq')">{{$t('FAQ')}}</a>
        </div>
      </div>
      <div class="copyright">{{$t('Copyright')}}</div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      info:{},
      isShow:1,
      isEN:'bur',
      score:'',
      mobile:'',
      switchFeature:false,
      product:{},
    }
  },
  mounted() {},
  created(){
    const urlToken = this.$route.query.token
    const token = this.$route.query.encrypte_data
    this.isEN = localStorage.getItem('lang')
    if(urlToken){
      localStorage.setItem('token', urlToken)
      const query = Object.assign({}, this.$route.query)
      delete query.token
      this.$router.replace({path:'/', query:query})
      this.getHome()
      this.getProduct()
    }else if(this.$route.query.mobile){
      this.mobile = this.$route.query.mobile
      this.getLogin()
    }else if(token){
      this.getMobileWithToken(token);
    }else{
      this.getHome()
      this.getProduct()
    }
  },
  methods: {
    getLogin(){
      let that = this
      that.$parent.loadModal(true);
      let data = {
        mobile:that.mobile
      }
      that.$api.post('/api/user/fast_login',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.getHome();
          this.getProduct();
        }else{
          that.$utils.alertText(r.msg,80);
          this.$router.push({path:'/login',query: {mobile:that.mobile}})
        }
      })
    },
    getHome(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.score=r.data.score
          that.switchFeature=r.data.switch
        });
      })
    },
    getProduct(){
      let that =this;
      that.$api.get('/api/index/index_product',null,r =>{
        that.$parent.returnCode(r,function(){
          that.product=r.data
        });
      })
    },
    goDetail(path){
      this.$router.push({path:path});
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    },
    getMobileWithToken(token){
      let that = this
      that.$parent.loadModal(true);
      let data = {token:token}
      that.$api.post('/api/decry/get_mobile_token',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          let phone = r.data.mobile
          let reg = r.data.reg
          if (phone && reg){
            this.mobile = phone
            this.getLogin()
          }else{
            that.$router.push({path:'/sub',query: {mobile:phone}})
          }
        }else{
          that.$router.push({path:'/login'})
        }
      })
    }
  }
}
</script>

<style scoped>
.close{
  background: rgb(255 255 255 / 20%);
  color: #fff;
  width: 13.333rem;  /* 100px */
  height: 13.333rem; /* 100px */
  font-size: 8rem;   /* 60px */
  margin: 4rem auto 0; /* 30px */
  border-radius: 100px;
}
.new-img{
  margin: 5.333rem 5.333rem 0; /* 40px */
  width: auto;
}
.new-img .img-b{
  width: 48%;
  border: 0.533rem solid #0062ff; /* 4px */
  border-radius: 1.333rem;       /* 10px */
}
.img-b img{
  width: 100%;
  border-radius: 1.333rem;       /* 10px */
}
.snapbot-btn {
  background: url('../../static/images/snapbot-btn.png') no-repeat center center;
  background-size: contain;
  width: 80%;
  height: 5rem; /* 90px */
  border: none;
}
.two{
  background: url('../../static/images/fun_bg.png') no-repeat center center;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue